import { render, staticRenderFns } from "./ArgoWorkflowPage.vue?vue&type=template&id=371a8c5a&"
import script from "./ArgoWorkflowPage.vue?vue&type=script&lang=ts&"
export * from "./ArgoWorkflowPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports